export const getArboisData = () => ({
  name: "Arbois",
  region: "Jura",
  country: "France",
  description: "Arbois est la première AOC de France, créée en 1936. Cette sous-région du Jura est le cœur viticole de la région, produisant des vins rouges, blancs et rosés de grande qualité. Arbois est réputée pour ses vins traditionnels et ses méthodes de vinification ancestrales.",
  type: "subregion",
  area: "850 hectares",
  production: "35,000 hectolitres",
  climate: "Semi-continental avec influences montagneuses",
  soil: "Marnes grises et calcaires, argiles",
  characteristics: {
    "Terroir": "Marnes grises et calcaires du Jurassique, exposition sud-est",
    "Climat": "Semi-continental avec étés chauds et hivers froids",
    "Altitude": "250-400 mètres",
    "Exposition": "Sud-est dominante, protégée des vents froids"
  },
  grapeVarieties: {
    "Rouges": {
      "Poulsard": {
        description: "Cépage emblématique du Jura, produisant des vins légers et fruités",
        characteristics: "Peau fine, couleur claire, arômes de fruits rouges et d'épices",
        wineStyle: "Vins rouges légers, rosés délicats"
      },
      "Trousseau": {
        description: "Cépage rare et précieux, produisant des vins de garde",
        characteristics: "Peau épaisse, couleur profonde, tanins structurés",
        wineStyle: "Vins rouges puissants et complexes"
      },
      "Pinot Noir": {
        description: "Cépage bourguignon adapté au terroir jurassien",
        characteristics: "Arômes de fruits rouges, structure équilibrée",
        wineStyle: "Vins rouges élégants et fruités"
      }
    },
    "Blancs": {
      "Chardonnay": {
        description: "Cépage principal pour les vins blancs secs",
        characteristics: "Acidité vive, notes minérales, arômes de fruits blancs",
        wineStyle: "Vins blancs secs et aromatiques"
      },
      "Savagnin": {
        description: "Cépage unique au Jura, base du vin jaune",
        characteristics: "Acidité élevée, potentiel oxydatif, arômes complexes",
        wineStyle: "Vins blancs secs, vin jaune, vin de paille"
      }
    }
  },
  wineStyles: {
    "Rouge": "Vins légers et fruités, parfaits pour la gastronomie locale. Les Poulsard sont particulièrement appréciés pour leur finesse et leur élégance.",
    "Blanc": "Vins secs et minéraux, avec une belle acidité. Les Chardonnay et Savagnin expriment parfaitement le terroir jurassien.",
    "Rosé": "Rosés délicats et aromatiques, principalement issus du Poulsard. Parfaits pour l'apéritif et les entrées.",
    "Vin Jaune": "Vin blanc oxydatif unique, élevé sous voile de levures pendant 6 ans minimum.",
    "Vin de Paille": "Vin liquoreux rare, produit à partir de raisins séchés sur paille."
  },
  statistics: {
    "Surface": "850 hectares",
    "Production": "35,000 hectolitres",
    "Nombre de domaines": "80+",
    "Rouge": "60%",
    "Blanc": "30%",
    "Rosé": "10%"
  },
  history: "Arbois est la première AOC de France, créée en 1936. La viticulture y remonte à l'époque romaine. Au Moyen Âge, les moines ont développé les techniques viticoles. Louis Pasteur, natif d'Arbois, a contribué à la compréhension scientifique de la vinification. Aujourd'hui, Arbois reste le cœur viticole du Jura, avec ses méthodes traditionnelles et ses vins de qualité.",
  foodPairing: "Cuisine traditionnelle jurassienne : Comté, Morbier, vin jaune, volaille de Bresse, saucisse de Morteau, morilles, truites du Doubs, poulet au vin jaune, coq au vin jurassien. Les vins d'Arbois s'accordent parfaitement avec la gastronomie locale et les fromages affinés."
}); 